import { Button, Collapse, Divider, Input, message, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { CnGroupements } from "./facturation";
import { v4 } from "uuid";
import axios from "axios";

interface GroupementsFacturationProps {
    groupements: CnGroupements[]
    groupementsRef: React.MutableRefObject<CnGroupements[]>
    softaccessType: string
}

export function GroupementsFacturation(props: GroupementsFacturationProps) {

    const [groupements, setGroupements] = React.useState<CnGroupements[]>(props.groupements);
    const [searchText, setSearchText] = React.useState<string>("");
    const [filteredGroupements, setFilteredGroupements] = React.useState<CnGroupements[]>(props.groupements);
    const [addingGroupement, setAddingGroupement] = React.useState<boolean>(false);
    const [newGroupementName, setNewGroupementName] = React.useState<string>("");
    const orgiginalGroupements = React.useRef<CnGroupements[]>(props.groupements);

    useEffect(() => {
        orgiginalGroupements.current = props.groupements;
    }, []);

    useEffect(() => {
        setGroupements(props.groupements);
    }, [props.groupements]);

    useEffect(() => {
        setFilteredGroupements(groupements.filter(g => g.name.toLowerCase().includes(searchText.toLowerCase())));
    }, [searchText, groupements]);


    return (
        <div>

            {addingGroupement ? (
                <>
                    <Input placeholder="Nom du groupement" value={newGroupementName} onChange={e => setNewGroupementName(e.target.value)} style={{ marginBottom: 16 }} />
                    <br />
                    <Button type="primary" style={{ marginRight: 8 }} onClick={() => {
                        //add groupement logic here
                        setGroupements([...groupements,  {
                            id: v4(), name: newGroupementName, softaccessType: props.softaccessType, prices: props.softaccessType === 'cnegoce' ? {
                                "Licence 1 à 10 utilisateurs": 49,
                                "Licence 11 à 20 utilisateurs": 46,
                                "Licence 21 à 40 utilisateurs": 42,
                                "Licence Plus de 40 utilisateurs": 40
                            } : {
                                "Licence principale": 495,
                                "Licence secondaire": 15
                            },
                            status: 'added'
                        }]);
                        setAddingGroupement(false);
                        setNewGroupementName("");
                    }}>Ok</Button>
                    <Button onClick={() => {
                        setAddingGroupement(false);
                        setNewGroupementName("");
                    }}>Annuler</Button>
                </>
            ) : (
                <Button icon={<PlusOutlined />} onClick={() => setAddingGroupement(true)} type='primary' style={{ marginBottom: 16 }}>Ajouter un groupement</Button>)
            }
            <Divider />
            {groupements.length === 0 ? <p>Aucun groupement disponible.</p> : <Input placeholder="Rechercher un groupement" value={searchText} onChange={e => {
                setSearchText(e.target.value);
            }} style={{ marginBottom: 16 }} />}
            <br />
            <Collapse accordion>
                {filteredGroupements.map((groupement, index) => (
                    <Collapse.Panel header={<>
                        {groupement.name}
                        {groupement.status === "added" || groupement.status === "modified" ? <>
                            <Typography.Text type="warning" style={{ marginLeft: 8 }}>(Non enregistré)</Typography.Text>
                            <Button type="primary" style={{ marginLeft: 16 }} onClick={() => {
                                axios.post('/api/groupements/save', {
                                    id: groupement.id,
                                    name: groupement.name,
                                    softaccessType: groupement.softaccessType,
                                    prices: JSON.stringify(groupement.prices)
                                }).then(() => {
                                    const newGroupements = [...groupements];
                                    newGroupements[index] = { ...newGroupements[index], status: undefined };
                                    setGroupements(newGroupements);
                                    props.groupementsRef.current = [
                                        ...props.groupementsRef.current.filter(g => g.softaccessType !== props.softaccessType),
                                        ...newGroupements,
                                    ];
                                    message.success("Groupement enregistré avec succès.");
                                }, (e) => {
                                    //error handling
                                    message.error("Erreur lors de l'enregistrement du groupement.");
                                    console.error(e);
                                });
                            }}>Enregistrer</Button>
                        </>

                            : null}
                    </>} key={index}>
                        <p><strong>ID du groupement :</strong> {groupement.id}</p>
                        <p><strong>Tarifs :</strong></p>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            {(props.softaccessType === 'cnegoce'
                                ? ["Licence 1 à 10 utilisateurs", "Licence 11 à 20 utilisateurs", "Licence 21 à 40 utilisateurs", "Licence Plus de 40 utilisateurs"]
                                : ["Licence principale", "Licence secondaire"]
                            ).map((label) => (
                                <li key={label} style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }}>
                                    <span style={{ width: 250 }}>{label} :</span>
                                    <Input
                                        style={{ width: 120 }}
                                        value={groupement.prices[label as keyof CnGroupements['prices']]}
                                        onChange={e => {
                                            const newGroupements = [...groupements];
                                            const reallyModified = groupement.status !== 'added' && orgiginalGroupements.current.find(g => g.id === groupement.id)?.prices[label as keyof CnGroupements['prices']] !== parseFloat(e.target.value);
                                            newGroupements[index] = { ...newGroupements[index], prices: { ...newGroupements[index].prices, [label]: parseFloat(e.target.value) || 0 }, status: reallyModified ? 'modified' : groupement.status };
                                            setGroupements(newGroupements);
                                        }}
                                        suffix="€"
                                        type="number"
                                    />
                                </li>
                            ))}
                        </ul>

                    </Collapse.Panel>
                ))}
            </Collapse>


        </div>
    );
}
